import { Component, Input, OnChanges } from '@angular/core'

import { Aggregation } from '../../../shared/interfaces/visualizations/aggregation.interface'

@Component({
  selector: 'app-aggregation-widget',
  templateUrl: './aggregation-widget.component.html',
  styleUrls: ['./aggregation-widget.component.scss']
})
export class AggregationWidgetComponent implements OnChanges {
  @Input() aggregations: Aggregation[]
  @Input() loading: boolean
  @Input() layout: 'tabs' | 'list' = 'tabs'

  selectedAggregation: Aggregation

  ngOnChanges() {
    if (this.aggregations && this.layout === 'tabs') {
      this.selectedAggregation = this.aggregations[0]
    }
  }
}
